module.exports = __webpack_public_path__ + "static/media/Team2.dd1e6fd5.png";